module.exports = __webpack_public_path__ + "static/media/hamilton.6925a0d1.gif";